<template>
    <v-container fluid>
    <field-form hide-default-button @save="save">
    <confirm-dialog title="dialog.unsaved.title" button-caption="dialog.leave" v-model="leaveDialog" @confirm="confirmLeave(true)" @cancel="confirmLeave(false)">
          {{ $t('dialog.unsaved.text') }}
    </confirm-dialog>
    <v-dialog v-model="sesdialog">
        <v-card>
            <v-card-title>{{ $t('templates.ses.title') }}</v-card-title>
            <v-textarea :rows="25" :value="sestemplate" />
        </v-card>
    </v-dialog>
    
    <newsletter-editor v-if="item" ref="editor" 
    :campaign="item.id" 
    :newsletter="fields.unlayerData" 
    :preview.sync="htmlpreview"
    :html.sync="htmltemplate"
    :text.sync="texttemplate" 
    :valid.sync="valid" 
    :specs.sync="specs" 
    :unsubscribe.sync="unsubscribe"
    :specsNew.sync="templateSpecsNew"
    :specsCategories.sync="templateSpecsCategories"
    :productCategories="[]" 
    @save="updateTemplate"
    dnsName="dreamroi.com" />
    
    <v-navigation-drawer app right clipped width="350" permanent>
    <v-card elevation="0">
        <v-card-title>{{ $t('templates.title') }}</v-card-title>
        <v-card-text>
            <v-text-field :label="$t('common.name')" v-model="fields.name" :rules="[ rules.required ]"/>
            <v-text-field :label="$t('templates.ordering')" :hint="$t('templates.orderingHint')" persistent-hint v-model.number="fields.order" type="number"/>
            <v-switch :disabled="!fields.preview || !unsubscribe || !valid" :label="$t('templates.public')" v-model="fields.public" />
            </v-card-text>
            <v-subheader>{{ $t('templates.imagePreview') }}</v-subheader>
            <v-card-text>
            <v-img v-if="fields.preview" :src="fields.preview" style="width:100%" />
            <v-alert type="warning" colored-border border="left"  v-else>No preview available. You can't publish the template until image preview is set.</v-alert>
            <v-alert type="error" colored-border border="left"  v-if="!valid">Invalid template. {{ specs.recommendationsCount > 10 ? 'Exceeded maximum number of recommendations' : 'Number of macros do not match.' }}</v-alert>
            <v-alert type="error" colored-border border="left"  v-if="!unsubscribe">The template does not contain unsubscribe link. You can't publish it.</v-alert>
            <v-file-input label="Upload new preview image" show-size v-model="file" clearable accept="image/png, image/jpeg" />
        </v-card-text>
        <v-card-actions>
        <save-button card :saving="saving"/>
        <v-btn text @click="getHTML">View SES template</v-btn>
        </v-card-actions>
    </v-card>
    <v-card elevation="0">
        <v-card-title>HTML preview</v-card-title>
        <v-card-text>
            Use to generate the image preview.
        </v-card-text>
            <v-subheader>Strip description</v-subheader>
        <v-card-text>
            <v-slider thumb-label="always" :thumb-size="24" min="0" max="150" v-model.number="specs.stripDescription" persistent-hint  hint="0 means no stripping" />
        </v-card-text>
        <v-card-actions>
        <v-btn text @click="generateHTML" :loading="htmlgen"><v-icon left>$generate</v-icon>Generate</v-btn>
        <v-btn :disabled="!htmllink" color="primary" text :href="htmllink" target="_blank"><v-icon left>$openInNew</v-icon>Open</v-btn>
        </v-card-actions>
    </v-card>
    </v-navigation-drawer>
    </field-form>
    </v-container>
</template>
<script>

import NewsletterEditor from '@/components/NewsletterEditor';
import EntityForm from '@/mixins/entity-form'
import ConfirmLeave from '@/mixins/confirm-leave'
import SaveButton from '@/components/SaveButton'

export default {
    name: 'TemplateDesigner',
    mixins: [EntityForm, ConfirmLeave],
    components: {
        NewsletterEditor,
        SaveButton
    },
    data() {
        return {
            endpoint: 'nstemplates',
            file: null,
            valid: true,
            htmlpreview: null,
            htmltemplate: null,
            texttemplate: null,
            sestemplate: null,
            sesdialog: false,
            htmllink: null,
            htmlgen: false,
            unsubscribe: true,
            fields: {
                name: null,
                order: null,
                public: false,
                unlayerData: null,
                preview: null
            },
            specs: {
                stripDescription: 0
            },
            templateSpecsNew: null,
            templateSpecsCategories: null
        }
    },
    computed: {
    },
    methods: {
        async getHTML() {
            await this.$refs.editor.getTemplate();
            // GET string for SES - JSON.stringify, escaped quotes
            this.sestemplate=JSON.stringify({
                templateSpecs: this.specs,
                templateSES: JSON.stringify({
                HtmlPart: this.htmltemplate,
                TextPart: this.texttemplate
            })});
            this.sesdialog = true;
        },
        updateTemplate(data) {
            console.debug('Updating template...');
           
            //console.debug(`Saving unlayer! ${JSON.stringify(data) === JSON.stringify(this.fields.unlayerData)}`);
            this.fields.unlayerData = data;
            //console.debug(`Saved unlayer! ${JSON.stringify(this.item.unlayerData) === JSON.stringify(this.fields.unlayerData)}`);
            
            this.dirty = true;
        },
        async beforeSave(fields) {
            if(this.file) {
                fields.preview = await this.$store.dispatch('nstemplates/uploadPreview',{ file: this.file });
            }
            this.dirty = false;
        },
        async generateHTML() {
            this.htmlgen = true;
            /* eslint-disable no-constant-condition*/
            if(true) {
                if(!this.htmlpreview) {
                    this.$refs.editor.getPreview();
                }
                let key = await this.$store.dispatch('nstemplates/uploadPreview', { file: { type: 'text/html', name: 'preview.html' }, content: this.htmlpreview } );
                this.htmllink = await this.$store.dispatch('nstemplates/getS3Link', { key });
            } else {
                let url = await this.$store.dispatch('nstemplates/getUnlayerPreview', { template: this.fields.unlayerData });
                this.htmllink = url;
            }
            /* eslint-enable no-constant-condition*/
            this.htmlgen = false;
        }
    },
    mounted() {
    }
}
</script>